import { render, staticRenderFns } from "./TaxonomySingleName.vue?vue&type=template&id=d7a29074&"
import script from "./TaxonomySingleName.vue?vue&type=script&lang=js&"
export * from "./TaxonomySingleName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports